import { useSelector } from 'react-redux'

import { selectLineValues, selectNewNumber, selectDonowOwnerName } from '../../store/line.selectors'

import { SignUpType, PortabilityType, Owner } from '~/basket/model/lines/signup.model'
import { RootState } from '~/core/store/root.reducer'
import { selectCustomerFullName } from '~/customer/store/customer.selectors'

export default function useLineSummary(id: string) {
  const {
    signUp: { signUpType, lineNumber, portabilityType, isSameOwner, donorOwner },
  } = useSelector((state: RootState) => selectLineValues(state, id))

  const donorOwnerName = useSelector((state: RootState) => selectDonowOwnerName(state, id))

  const customerFullName = useSelector(selectCustomerFullName)

  const isNewLine = signUpType === SignUpType.NEW_LINE

  const signUpTypeLiteral = isNewLine ? 'Alta nueva' : 'Portabilidad'

  const newNumber = useSelector((state: RootState) => selectNewNumber(state, id))

  const numberLiteral = isNewLine ? 'Nuevo número' : 'Número a portar'

  const linePhoneNumber = isNewLine ? newNumber : lineNumber

  const commonValues = { signUpTypeLiteral, numberLiteral, linePhoneNumber }

  const portabilityTypeLiteral =
    PortabilityType.POSTPAID === portabilityType ? 'Contrato' : 'Prepago'

  const isSameDonor = Owner.SAME === isSameOwner

  const ownerName = isSameDonor ? `El mismo (${customerFullName})` : donorOwnerName || ''

  const donorDocId = donorOwner?.docId || ''

  return {
    isNewLine,
    newLineValues: commonValues,
    portabilityValues: {
      ...commonValues,
      portabilityTypeLiteral,
      ownerName,
      isSameDonor,
      donorDocId,
    },
  }
}
